import { Button, Form, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CreateOperatorRequest } from '@/types/apis/operators/CreateOperatorRequest'

type Props = {
  loading: boolean
  onSubmit: (formValues: CreateOperatorRequest) => void
}

const CreateOperatorForm = ({ loading, onSubmit }: Props) => {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Form.Item
        label={t('components.pages.operators.create.form.code')}
        name="code"
        rules={[{ required: true, message: t('components.pages.operators.create.form.requireCode') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.operators.create.form.name')}
        name="name"
        rules={[{ required: true, message: t('components.pages.operators.create.form.requireName') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {t('components.pages.operators.create.form.submit')}
        </Button>
      </Form.Item>
    </Form>
  )
}

CreateOperatorForm.displayName = 'CreateOperatorForm'
export default CreateOperatorForm
